import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { MediaTypes } from '@common/services/files.service';
import { BaseMiscApiService } from '@common/api/base-misc-api.service';

import { ActivityByServerApi } from './models/activity';
import { ResultApi } from '@common/api/result-api';

@Injectable({
    providedIn: 'root'
})
export class ServerMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.segmentApi = '/hist/netbackup';
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.download(`/export/latestimages${qs}`, format);
    }

    getActivity (qs: string): Observable<ResultApi<ActivityByServerApi[]>>
    {
        if (AppConstants.IsDataLocal('bckp'))
        {
            return this.http.get<ResultApi<ActivityByServerApi[]>>('assets/data/bckp/servers-heatmap.json');
        }

        return this.get<ResultApi<ActivityByServerApi[]>>(`/activity${qs}`);
    }

    exportActivity (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.download(`/export/activity${qs}`, format);
    }
}
